// extracted by mini-css-extract-plugin
export default {"container":"phone_container__2c7bE","cellNumber":"phone_cellNumber__1NUQb","cellTrait":"phone_cellTrait__2RUQ5"};